import { useEffect, useState } from 'react'
import { Button, Col, Container, Modal, Form, Row, Spinner, ModalHeader } from 'react-bootstrap'
import { useLoading } from '../../hooks/LoadingContext'
import api from '../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../utils/errorApi'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'
import { IMaskInput } from 'react-imask'
import { states } from '../../utils/states'
import ConfirmationModal from '../ConfirmationModal'

import styles from './styles.module.css'

const deliveryStatus = ['allocated', 'in_progress', 'on_route']

const EditRequestModal = ({
  request,
  show,
  role,
  onClose,
  onEdit = (updatedRequest) => {},
  onDelete = (removedRequestId) => {},
}) => {
  const [invoice, setInvoice] = useState('')
  const [requestNumber, setRequestNumber] = useState('')
  const [invoiceNumber, setInvoiceNumber] = useState('')
  const [cep, setCep] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [neighborhood, setNeighborhood] = useState('')
  const [street, setStreet] = useState('')
  const [streetNumber, setStreetNumber] = useState('')
  const [weight, setWeight] = useState()
  const [weightString, setWeightString] = useState('')
  const [startDate, setStartDate] = useState('')
  const [complement, setComplement] = useState('')
  const [phone, setPhone] = useState('')
  const [receiverName, setReceiverName] = useState('')
  const [status, setStatus] = useState('')
  const [unallocate, setUnallocate] = useState(false)
  const [showUnallocateModal, setShowUnallocateModal] = useState(false)
  const [note, setNote] = useState('')
  const [isInternalTransfer, setIsInternalTransfer] = useState(false)
  const [id, setId] = useState(0)

  const { isLoading, setIsLoading } = useLoading()
  const [showModalRemove, setShowModalRemove] = useState(false)

  useEffect(() => {
    if (!request || !show) return
    setInvoice(request.invoice)
    setRequestNumber(request.request_number)
    setInvoiceNumber(request.invoice_number)
    setCep(request.cep ?? '')
    setCity(request.city)
    setState(request.state)
    setNeighborhood(request.neighborhood)
    setStreet(request.street)
    setStreetNumber(request.street_number)
    setWeight(request.weight)
    setWeightString(request.weight.toString().replace('.', ','))
    setStartDate(request.start_date?.split('T')[0])
    setComplement(request.complement)
    setPhone(request.phone)
    setReceiverName(request.receiver_name)
    setStatus(request.status)
    setNote(request.note ?? '')
    setId(request.id)
    setIsInternalTransfer(request.is_internal_transfer)
  }, [request, show])

  const isValidModel = () => {
    if (
      !(
        invoice &&
        city &&
        state &&
        neighborhood &&
        street &&
        streetNumber &&
        weight &&
        receiverName
      )
    )
      return false
    return true
  }

  const handleShowModalRemove = () => {
    setShowModalRemove(true)
  }

  const handleCloseModalRemove = () => {
    setShowModalRemove(false)
  }

  const handleRemove = async (event) => {
    event.preventDefault()
    setIsLoading(true)

    try {
      await api.delete(`/${role}/requests/${id}`)
      onDelete(id)
      toast.info('Pedido removido com sucesso!', { autoClose: 3000 })
      setShowModalRemove(false)
      setIsLoading(false)
      onClose()
    } catch (err) {
      setIsLoading(false)
      toast.error(errorApi(err, 'Falha ao remover o pedido! Tente novamente.'))
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    setIsLoading(true)
    let apiUrl = `/${role}/requests/${id}`
    if (unallocate) apiUrl += '?unbind=true'

    try {
      let modelObj = {
        invoice: invoice,
        request_number: requestNumber,
        invoice_number: invoiceNumber,
        cep: cep,
        city: city,
        state: state,
        neighborhood: neighborhood,
        street: street,
        street_number: streetNumber,
        complement: complement,
        phone: phone,
        receiver_name: receiverName,
        weight: weight,
        start_date: startDate ? new Date(startDate).toISOString() : '',
        note: note,
        is_internal_transfer: isInternalTransfer,
      }

      await api.put(apiUrl, modelObj)
      onEdit({ ...request, ...modelObj })
      toast.info('Pedido atualizado com sucesso!')
      setIsLoading(false)
      onClose()
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao editar o pedido! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  return (
    <>
      {request && (
        <Modal show={show} onHide={onClose} size="xl">
          <ModalHeader closeButton>
            <h2 style={{ textAlign: 'center', width: '100%', margin: 0 }}>Editar pedido</h2>
          </ModalHeader>
          <LoadingSpinner text="Salvando informações. Aguarde..." />
          <Container>
            <Col className={styles.formContainer}>
              <Row>
                <Col md={6}>
                  <Form.Label className={styles.label}>Nota fiscal*</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui a nota fiscal"
                    value={invoice}
                    onChange={(event) => setInvoice(event.target.value)}
                  />
                </Col>
                <Col md={6} className="mt-md-0 mt-3">
                  <Form.Label className={styles.label}>Peso total do pedido (kg)*</Form.Label>
                  <Form.Control
                    className={styles.input}
                    as={IMaskInput}
                    mask={[
                      {
                        mask: Number,
                        radix: ',',
                      },
                    ]}
                    placeholder="Digite aqui o peso"
                    value={weightString}
                    onChange={(event) => {
                      setWeightString(event.target.value)
                      setWeight(Number(event.target.value.replace(',', '.')))
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Cidade*</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui a cidade"
                    value={city}
                    onChange={(event) => setCity(event.target.value)}
                  />
                </Col>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Estado*</Form.Label>
                  <Form.Select
                    className={styles.input}
                    value={state}
                    onChange={(event) => setState(event.target.value)}
                  >
                    <option value="">Selecione o estado</option>
                    {states.map((state) => (
                      <option key={state}>{state}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Rua*</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui a rua"
                    value={street}
                    onChange={(event) => setStreet(event.target.value)}
                  />
                </Col>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Bairro*</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui o bairro"
                    value={neighborhood}
                    onChange={(event) => setNeighborhood(event.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Número*</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui o número"
                    value={streetNumber}
                    onChange={(event) => setStreetNumber(event.target.value)}
                  />
                </Col>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>CEP</Form.Label>
                  <Form.Control
                    className={styles.input}
                    as={IMaskInput}
                    mask="00000-000"
                    placeholder="Digite aqui o CEP"
                    value={cep}
                    onChange={(event) => setCep(event.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Complemento</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui o complemento"
                    value={complement}
                    onChange={(event) => setComplement(event.target.value)}
                  />
                </Col>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Nome do destinatário*</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui o nome do destinatário"
                    value={receiverName}
                    onChange={(event) => setReceiverName(event.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Telefone do destinatário</Form.Label>
                  <Form.Control
                    className={styles.input}
                    as={IMaskInput}
                    mask={[
                      { mask: '(00) 00000000' }, // para números fixos (8 dígitos)
                      { mask: '(00) 000000000' }, // para números de celular (9 dígitos)
                    ]}
                    placeholder="Digite aqui telefone"
                    value={phone}
                    onChange={(event) => setPhone(event.target.value)}
                  />
                </Col>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Data de início da entrega</Form.Label>
                  <Form.Control
                    className={styles.input}
                    type="date"
                    min={new Date().toISOString().split('T')[0]}
                    placeholder="Selecione a data"
                    value={startDate}
                    onChange={(event) => setStartDate(event.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Número do pedido</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui o número do pedido"
                    value={requestNumber}
                    onChange={(event) => setRequestNumber(event.target.value)}
                  />
                </Col>
                <Col md={6} style={{ marginTop: 15 }}>
                  <Form.Label className={styles.label}>Número da nota fiscal</Form.Label>
                  <Form.Control
                    className={styles.input}
                    placeholder="Digite aqui o número da nota fiscal"
                    value={invoiceNumber}
                    onChange={(event) => setInvoiceNumber(event.target.value)}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 15, textAlign: 'left' }}>
                <Col>
                  <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                    Observação
                  </Form.Label>
                  <Form.Control
                    className={styles.input}
                    as="textarea"
                    rows={2}
                    placeholder="Digite uma observação a respeito da entrega (opcional)"
                    value={note}
                    onChange={(event) => setNote(event.target.value)}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 15 }}>
                {deliveryStatus.includes(status) && (
                  <Col>
                    <Form.Switch
                      className={styles.label}
                      label="Desalocar pedido"
                      checked={unallocate}
                      onChange={() => {
                        if (!unallocate) setShowUnallocateModal(true)
                        setUnallocate(!unallocate)
                      }}
                    />
                  </Col>
                )}
                {['unallocated', 'allocated'].includes(status) && (
                  <Col>
                    <Form.Switch
                      className={styles.label}
                      label="É transferência interna?"
                      checked={isInternalTransfer}
                      onChange={() => {
                        setIsInternalTransfer(!isInternalTransfer)
                      }}
                    />
                  </Col>
                )}
              </Row>
              <Col style={{ marginTop: 15, textAlign: 'right' }}>
                <Button
                  className={styles.deleteBtn}
                  disabled={isLoading}
                  onClick={handleShowModalRemove}
                >
                  {isLoading ? (
                    <Spinner
                      animation="border"
                      size="sm"
                      style={{
                        color: '#fff',
                        marginRight: 10,
                      }}
                    />
                  ) : (
                    'Remover pedido'
                  )}
                </Button>
                <Button
                  className={styles.btn_submit}
                  disabled={isLoading || !isValidModel()}
                  onClick={(event) => handleSubmit(event)}
                >
                  {isLoading ? (
                    <Spinner
                      animation="border"
                      size="sm"
                      style={{
                        color: '#fff',
                        marginRight: 10,
                      }}
                    />
                  ) : (
                    'Atualizar pedido'
                  )}
                </Button>
              </Col>
            </Col>
          </Container>
          <ConfirmationModal
            show={showModalRemove}
            message="Tem certeza de que deseja remover o pedido?"
            action={handleRemove}
            closeModal={handleCloseModalRemove}
          ></ConfirmationModal>
          <Modal centered show={showUnallocateModal} onHide={() => setShowUnallocateModal(false)}>
            <Modal.Header closeButton />
            <Modal.Body>
              <p style={{ textAlign: 'justify' }}>
                Ao ativar a opção <b>Desalocar pedido</b> e atualizá-lo, clicando no botão{' '}
                <b>Atualizar pedido</b>, o mesmo será <b>removido do veículo atual</b> e a nova data
                de disponibilização para entrega será a selecionada no campo <b>Data de Início</b>,
                deste mesmo formulário.
              </p>
              <Row>
                <Col style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    onClick={() => setShowUnallocateModal(false)}
                    className={styles.confirmationModalBtn}
                  >
                    Estou ciente
                  </Button>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </Modal>
      )}
    </>
  )
}

export default EditRequestModal
